<template>
	<div class="page-about">
		<section class="container">
			<div class="row justify-content-md-between align-items-center justify-content-center text-center text-md-left">
				<div class="col-md-6">
					<h2>BattleWikiX</h2>
					<p class="lead pr-md-35">A system for preserving and exchanging knowledge in an organization where being online is not a given</p>
					<router-link to="/contact">Get in Touch »</router-link> 
				</div>
				<div class="col-md-5 col-4 order-first order-md-last spaced-sm">
					<img src="@/assets/battle-wiki-x.png" alt="BattleWikiX">
				</div>
			</div>
		</section>		
		<section class="gray-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<h2>A tool for operators</h2>
						<img src="@/assets/BW_example1.png" alt="BattleWikiX">
						<p class="lead">With a clean yet powerful interface, the user will quickly master the system.</p>
					</div>
				</div>
			</div>
		</section>
		<section class="features">
			<div class="container">
				<div class="row text-center text-md-left mb-5">
					<div class="col-md-4">
						<div class="box">
							<h4>Built for the user</h4>
							<p>Our focus is to make a system that will feel like the right tool for the job.</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Flexible data structure</h4>
							<p>BW-X is designed to consume all sorts of pre-existing databases.</p>						
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Powerful search</h4>
							<p>Search across the entire knowledge base in the blink of an eye.</p>						
						</div>
					</div>
				</div>
<!-- 				<div class="row text-center text-md-left">
					<div class="col-md-4">
						<div class="box">
							<h4>Experience Quality</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Robust Design</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>						
						</div>
					</div>
					<div class="col-md-4">
						<div class="box">
							<h4>Downloadable Data</h4>
							<p>Lorem ipsum dolor sit amet, consect beatae adipisicing elit.</p>						
						</div>
					</div>
				</div> -->
			</div>
		</section>
		<section class="gray-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<h2>Tailor made workflow</h2>
						<img src="@/assets/BW_workflow_diagram.png" alt="BattleWikiX">
						<p class="lead">BW-X is designed to provide operational support without the luxury of being online. Each node functions isolated, or exchanges information at the users discretion</p>
						
					</div>
				</div>
			</div>
		</section>
		<section class="cta product-cta">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center">
						<!-- <h2>Let's discuss</h2>
						<p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam, consequuntur eligendi a architecto est ab explicabo sequi.</p> -->
						<router-link to="/contact" class="btn btn-primary btn-main">Get in touch</router-link>
					</div>
				</div>
			</div>
		</section>
	</div>	
</template>

<script>
export default {
	name: 'BattleWikiX',
	components: {

	}
}
</script>

<style>
	.product-cta {
		background-image: url(~@/assets/slide-4.jpg);
		background-position: center;
	}
</style>
